export const isNoAuthRoute = (route?: {
	matched?: Array<{ meta?: { requiresNoAuth?: boolean } }>;
}) =>
	Boolean(
		route?.matched?.some((record) => Boolean(record.meta?.requiresNoAuth))
	);
